import { Toolbar, SxProps, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';

/**
 * GridToolbarContainerの代替コンポーネント
 * DataGridのカスタムツールバーとして使用できます
 */
export type ToolbarContainerProps = {
  children: ReactNode;
  sx?: SxProps<Theme>;
};

const ToolbarContainer: FC<ToolbarContainerProps> = ({ children, sx }) => {
  return (
    <Toolbar
      sx={{
        width: '100%',
        px: 0,
        minHeight: '64px !important',
        borderBottom: 1,
        borderColor: 'divider',
        ...sx,
      }}
    >
      {children}
    </Toolbar>
  );
};

export default ToolbarContainer;
